import React, { ReactElement, memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

export interface IImageProps {
  height?: number | string;
  width?: number | string;
  image: string;
  backgroundSize: string;
}

const useStyles = makeStyles<AlyceTheme, IImageProps>(() => ({
  image: {
    height: props => props.height,
    width: props => props.width,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: props => props.backgroundSize,
    backgroundImage: props => `url(${props.image})`,
    borderRadius: 5,
  },
}));

const Image = ({ image, height = '100%', width = '100%', backgroundSize = 'cover' }: IImageProps): ReactElement => {
  const classes = useStyles({ image, backgroundSize, height, width });
  return <Box className={classes.image} />;
};

export default memo(Image);
